import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useInView } from 'react-intersection-observer';

const Hosting: React.FC = () => {
  const { t } = useTranslation('pricing');
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const hosting = t('hosting', { returnObjects: true }) as Array<{
    name: string;
    price: string;
    period: string;
    features: string[];
  }>;

  return (
    <section className="py-20 section-dark" ref={ref}>
      <div className="container-custom">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4 gradient-text">
            {t('hostingSection.title')}
          </h2>
          <p className="text-xl text-secondary max-w-2xl mx-auto">
            {t('hostingSection.subtitle')}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {hosting.map((plan, index) => (
            <motion.div
              key={index}
              className="card p-8"
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <h3 className="text-2xl font-bold mb-6">{plan.name}</h3>
              <div className="mb-6">
                <span className="text-4xl font-bold text-primary-500">
                  {plan.price}
                </span>
                <span className="text-secondary ml-2">
                  {plan.period}
                </span>
              </div>
              <ul className="space-y-3">
                {plan.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-start">
                    <svg
                      className="w-5 h-5 text-primary-500 mr-2 flex-shrink-0 mt-0.5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="text-secondary">{feature}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hosting;
